import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dep: {},
};

const currentDepSlice = createSlice({
  name: 'dep',
  initialState,
  reducers: {
    setUpdatedep(state, action) {
      const { payload } = action;
      state.dep = payload;
    },
    clearDep(state) {
      state.dep = initialState.dep;
    },
  },
});

export const { setUpdatedep, clearDep } = currentDepSlice.actions;
export default currentDepSlice.reducer;
